import { useContext } from 'react';

import { CommitmentsContext } from '../providers';

export const useCommitmentsContext = () => {
  return useContext(CommitmentsContext);
};
